import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './ViewTrimHighlights.styles';
import { pushViewTrimHighlightsCtaEvent } from '../../utils/gtmEvents';
const ViewHighlightsButton = themeStyles.apply(Button, 'ViewHighlightsButton');
const ViewTrimHighlightsUI = ({ linkUrl, ctaLabel, gtmPayload }) => (_jsx(ViewHighlightsButton, { as: RoutableSitecoreLink, styling: "secondary", field: {
        value: { href: linkUrl, target: '_blank' },
    }, "data-testid": "cy-viewtrimhighlights-cta", onClick: () => pushViewTrimHighlightsCtaEvent(gtmPayload), children: ctaLabel }));
export default ViewTrimHighlightsUI;
